import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, getCurrentInstance } from 'vue';
	
	
export default /*#__PURE__*/_defineComponent({
  __name: 'AddBtn',
  emits: ["change"],
  setup(__props, { emit: __emit }) {

	const { proxy } = getCurrentInstance() as any;
	const emits = __emit;
	const text = ref("添加");
	
	const Submit = () => {
		emits("change");
	};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_button, {
      class: "add-btn-1",
      type: "primary",
      onClick: Submit
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(text.value), 1)
      ]),
      _: 1
    })
  ]))
}
}

})